import { css } from 'lit';

export default [
  css`
  .step-wizard-progress {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      margin: .5rem 0 2rem 0;
      padding: 0;
      list-style: none;
    }
    .step-wizard-progress-item {
      flex: 1 1 0;
      position: relative;
      text-align: center;
      min-width: 80px;
    }
    .step-wizard-progress-line-before,
    .step-wizard-progress-line-after {
      position: absolute;
      top: 24px;
      height: 2px;
      background: #d3d3d3;
      z-index: 0;
      left: 0;
      right: 0;
    }
    .step-wizard-progress-line-before.complete,
    .step-wizard-progress-line-after.complete {
      background: var(--tenable-step-wiz-progress-color, #1e2426);
    }
    .step-wizard-progress-line-before {
      left: -50%;
      right: 50%;
    }
    .step-wizard-progress-line-after {
      left: 50%;
      right: -50%;
    }
    .step-wizard-progress-icon {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .step-wizard-progress-btn {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1px solid var(--tenable-step-wiz-progress-color, #1e2426);
      background: #fff;
      color: var(--tenable-step-wiz-progress-color, #1e2426);
      font-weight: bold;
      font-size: 0.91875rem;
      margin-bottom: 0.5rem;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;
    }
    .step-wizard-progress-btn.done {
      background: var(--tenable-step-wiz-progress-color, #1e2426);
      color: #fff;
    }
    .step-wizard-progress-btn.incomplete {
      background: #fff;
      color: #5B6062;
      border-color: #5B6062;
    }
    .step-wizard-progress-btn.current {
      box-shadow: 0 0 0 .2rem var(--tenable-step-wiz-progress-shadow-color, #e7ff00);
      background-color: var(--tenable-step-wiz-progress-color, #1e2426);
      color: #fff;
    }
    .step-wizard-progress-btn.disabled {
      opacity: 1;
      cursor: not-allowed;
    }
    .step-wizard-progress-label {
      font-size: 0.95rem;
      margin-top: 0.2rem;
      color: var(--tenable-step-wiz-label-color, #1e2426);
      font-weight: 500;
    }
    .step-wizard-progress-label.done {
      color: var(--tenable-step-wiz-label-color, #1e2426);
    }
    .step-wizard-progress-label.incomplete {
      color: var(--tenable-step-wiz-label-incomplete-color, #5B6062);
    }
  `,
];
